import { dynamicSort } from "../../modules/utils";

const state = {
  currentList: [],
  addresses: [],
  searchResults: [],
  currentDataSets: [
    {
      id: "currentSelection",
      title: "Current Selection",
      color: "darkgreen",
      selected: false,
    },
  ],
  colors: [
    "darkblue",
    "purple",
    "red",
    "orange",
    "gold",
    "green",
    "brown",
    "cyan",
    "coral",
    "blueviolet",
    "chocolate",
    "deeppink",
    "darkred",
    "pink",
    "darkgray",
    "black",
    "crimson",
    "darkmagenta",
    "darksalmon",
    "lightblue",
    "yellow",
  ],
  dataSetsWithData: [],
};

const getters = {
  currentRecordList(state) {
    return state.currentList;
  },
  currentAddresses(state) {
    return state.addresses;
  },
  currentSearchResults(state) {
    return state.searchResults;
  },
  currentSetIds(state, getters) {
    return Array.from(new Set(getters.allRecords.map(x => x.setId)));
  },
  allRecords(state) {
    let records = state.searchResults.filter(x => state.currentList.includes(x.externalId));
    let all = [...records];
    for (let record of records) {
      if (record.setId) {
        let pair = state.searchResults.filter(x => x.setId === record.setId);
        let allIds = all.map(x => x.externalId);
        let toAdd = pair.filter(x => !allIds.includes(x.externalId));
        all = all.concat(toAdd);
      }
    }
    // all.sort(dynamicSort("setId"));
    let uniqueSets = Array.from(new Set(all.map(x => x.setId)));
    all.forEach(x => (x.setName = `Set ${uniqueSets.indexOf(x.setId) + 1}`));
    return all;
  },
  orderedRecords(state, getters) {
    let records = [];
    for (let id of getters.currentSetIds) {
      let setData = getters.allRecords.filter(x => x.setId === id);
      if (setData.length > 1) {
        setData.sort(dynamicSort("plantPart", -1));
      }
      records = records.concat(setData);
    }
    return records;
  },
  currentDataSets(state) {
    return state.currentDataSets;
  },
  allActiveSetData(state) {
    let activeIds = state.currentDataSets.filter(x => x.selected).map(x => x.id);
    return state.dataSetsWithData.filter(x => activeIds.includes(x.id));
  },
  dataSetsWithData(state) {
    return state.dataSetsWithData;
  },
};

const mutations = {
  setCurrentList(state, list) {
    state.currentList = list;
  },
  setCurrentAddresses(state, addresses) {
    state.addresses = addresses;
  },
  setCurrentSearchResults(state, results) {
    state.searchResults = results;
  },
  setCurrentDataSets(state, dataSets) {
    dataSets = dataSets.map((x, i) => ({ ...x, color: state.colors[i] }));
    state.currentDataSets = dataSets;
  },
  setDataSetsWithData(state, data) {
    state.dataSetsWithData = [...state.dataSetsWithData, ...data];
  },
  dataSetActiveState(state, { id, val }) {
    state.currentDataSets = state.currentDataSets.map(x => (x.id === id ? { ...x, selected: val } : x));
  },
  updateDataSet(state, { id, dataSet }) {
    state.currentDataSets = state.currentDataSets.map(x => (x.id === id ? dataSet : x));
  },
};

export default {
  state,
  getters,
  mutations,
};
